import { render, staticRenderFns } from "./verify_phone.vue?vue&type=template&id=efde27de&"
import script from "./verify_phone.vue?vue&type=script&lang=js&"
export * from "./verify_phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports